class Timeline extends HTMLElement {
  constructor() {
    super();
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.ticking = false;
  }

  connectedCallback() {
    this.items = this.querySelectorAll('.timeline__item');
    this.media = this.querySelector('.timeline__col--media');
    this.desktopQuery = window.matchMedia('(min-width: 990px)');
    this.updateThreshold();
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  }

  updateThreshold() {
    this.threshold = this.desktopQuery.matches
      ? 120
      : this.media
        ? this.media.offsetHeight * 1.5
        : window.innerHeight * 0.5;
  }

  onScroll() {
    this.requestUpdate();
  }

  onResize() {
    this.updateThreshold();
    this.requestUpdate();
  }

  requestUpdate() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.ticking = false;
      this.update();
    });
  }

  update() {
    // Read all positions first, then write classes, to avoid layout thrashing
    const tops = Array.from(this.items, (item) => item.getBoundingClientRect().top);

    this.items.forEach((item, index) => {
      item.classList.toggle('is-active', tops[index] <= this.threshold);
    });
  }
}

customElements.define('component-timeline', Timeline);
